export default {
   layout: {
        zh: '中文简体',
        en: 'English',
        kr: '한국어',
        tc:'中文繁体',
        th:'泰语ภาษาไทย',
        vn:'Việt Nam'
    },
  footer: { desc: '' },
  menu: {
    home: '首頁',
    node: '節點',
    exchange: '兌換',
    staking: '質押',
    me: '我的'
  },
  home: {
    ecological: '生態節點',
    more: '查看更多',
    genesis: '鑽石節點',
    gold: '黃金節點',
    onlyLeft: '僅剩',
    coin: '配幣比',
    subscription: '購買節點',
    application: '生態應用場景',
    desc1: '商城積分兌換與商品支付',
    desc2: '節點認購、質押收益與治理投票',
    desc3: '黃金資產兌換(RWA映射)',
    desc4: '商家讓利及分紅激勵',
    desc5: '平台手續費結算及分潤分配',
    community: 'DAO 社區治理 及投票決策',
    partners: '合作夥伴',
    contact: '聯繫我們',
    limited: '限量',
    mat: '席',
    lock: '鎖倉釋放',
    sky: '天'
  },
  node: {
    ecology: '生態節點',
    meNode: '我的節點',
    genesis: '鑽石節點',
    onlyLeft: '僅剩',
    coin: '配幣比',
    subscription: '購買節點',
    diamond: '鑽石節點',
    bronze: '青銅節點',
    revenue: '查看收益',
    gold: '黃金節點',
    silver: '白銀節點',
    noNode: '還沒有節點，立即認購',
    totalCollection: '總領取',
    toBeClaimed: '待領取',
    claimed: '領取',
    totalRelease: '總釋放',
    released: '已釋放',
    toBeReleased: '待釋放',
    genesisReleased: '鑽石節點釋放',
    more: '下拉加載更多',
    nodeSubscription: '節點認購',
    receivedTo: '領取至',
    networkFee: '網絡費用',
    confirmSubscription: '確定認購',
    progress: '交易執行中',
    executionSuccessful: '執行成功',
    at: '在',
    view: '上查看',
    releaseRecord: '釋放記錄',
    claimRecord: '領取記錄',
    nonce: 'Nonce',
    claimIncome: '領取收益',
    quantityClaimed: '領取數量',
    pickup: '可領取',
    all: '全部',
    confirmToReceive: '確定領取',
  node0:'鑽石節點',
  node1:'鉑金節點',
  node2:'黃金節點',
  node3:'翡翠節點',
  node4:'白銀節點',
  node5:'青銅節點',

         release1:'KOL 激勵',
       release2:'全球空投',
       release3:'流動性池',
       release4:'創始團隊',
       release5:'生態基金',
       release6:'機構',
       release7:'全球節點',
       release8:'生態礦池',
       release9:'質押礦池',
       

       success:'成功',
       error:'失敗',
       nocount:'該節點已經售罄'

  },
  exchange: {
    at: '在',
    view: '上查看',
    more: '更多',
    indicator: '指標',
    market: '市價兌換',
    payment: '支付',
    all: '全部',
    received: '收到',
    slippage: '滑點',
    minimum: '收到的最小值',
    cost: '網絡費用',
    confirmExchange: '確定兌換',
    record: '歷史記錄',
    completed: '已完成',
    error: '失敗',
    downMore: '下拉加載更多',
    price: '價格',
    progress: '交易執行中',
    wallet: '發起錢包',
    refuse: '拒絕',
    nodeSubscription: '節點認購',
    executionSuccessful: '執行成功',
    nonce: 'Nonce',
    confirm: '確定'
  },
  me: {
    assets: '總資產',
    recharge: '充值',
    transfer: '轉出',
    record: '歷史記錄'
  },
  recharge: {
    recharge: '充值',
    title: '該地址僅支持 NEX 相關資產',
    address: '收款地址',
    copy: '複製',
    share: '分享'
  },
  record: {
    record: '記錄',
    all: '全部',
    recharge: '充值',
    transfer: '轉出',
    claimed: '領取'
  },
  transfer: {
    transfer: '轉出',
    address: '轉出地址',
    transferCoin: '轉賬代幣',
    pla: '請輸入轉出地址',
    network: '轉賬網絡',
    mainNetwork: '選擇主網',
    transferAmount: '轉出金額',
    withdraw: '最少提現20',
    all: '全部',
    balance: '可用餘額',
    tips: '請認真核對轉出地址和網絡，一經上鏈，資產將不可追回',
    amountReceived: '到賬數量',
    free: '網絡手續費'
  }
};